import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgFigma } from "react-icons/cg";
import { FaSteam } from "react-icons/fa";
import { FaPlay } from "react-icons/fa";
import { Link } from "react-router-dom";

function ProjectCards(props) {
  return (
    <Card className="project-card-view">
      {props.videoPath ? (
        <video
          src={props.videoPath}
          autoPlay
          loop
          muted
          playsInline
          style={{ width: "100%", aspectRatio: "16/10", objectFit: "cover", objectPosition: "top", padding: "20px", opacity: "0.8", borderRadius: "10px" }}
        />
      ) : (
        <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      )}
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        <Card.Text style={{ textAlign: "justify" }}>
          {props.description}
        </Card.Text>

      {props.figmaLink && (  
        <Button 
          variant="primary"
          href={props.figmaLink}
          target="_blank">
          <CgFigma /> &nbsp;
          {"Figma"}
        </Button>
      )}
        {"\n"}
        {"\n"}

        {props.videoLink && (
          <Button
            as={Link}
            to={props.videoLink}
            variant="primary"
            style={{ marginLeft: "10px" }}
          >
            <FaPlay /> &nbsp;
            {"Watch Video"}
          </Button>
        )}

        {props.steamLink && (
          <Button
            variant="primary"
            href={props.steamLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            <FaSteam /> &nbsp;
            {"Steam"}
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
